module.exports = __webpack_public_path__ + "img/9db4b2f.jpg";